function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "save",
  transform: "translate(-288 -283)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_318",
  "data-name": "Group 318",
  transform: "translate(267 261)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_319",
  "data-name": "Group 319",
  transform: "translate(29 29)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_29",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: "0.5px",
  d: "M29 29h7.455l1.491 1.491v7.455H29zm2.13.426h-1.7v8.094h8.09v-6.852l-1.241-1.241h-.463v2.556H31.13zm.426 2.13h3.834v-2.13h-3.834z",
  "data-name": "Path 29",
  transform: "translate(-29 -29)"
}))));

var SvgSave = function SvgSave(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSave, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/save.5edc7ec8.svg";
export { ForwardRef as ReactComponent };